"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectPropertyByString = exports.deepCopy = void 0;
const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
exports.deepCopy = deepCopy;
const getObjectPropertyByString = (jsonObject, path) => {
    const pathParts = path.split('.');
    let clonedJsonObject = (0, exports.deepCopy)(jsonObject);
    for (const pathPart of pathParts) {
        if (pathPart in clonedJsonObject) {
            clonedJsonObject = clonedJsonObject[pathPart];
        }
        else {
            return null;
        }
    }
    return clonedJsonObject;
};
exports.getObjectPropertyByString = getObjectPropertyByString;
